import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { replayWebhookDelivery } from "../../api/apiWebhooks";
import parseError from "../../utils/parseError";

export const useReplayWebhookDelivery = () => {
    const queryClient = useQueryClient();

    const { mutate: replayDeliveryMutate, isPending: isReplaying } = useMutation({
        mutationFn: replayWebhookDelivery,
        onSuccess: (res) => {
            toast.success(res?.message || "Delivery re-queued");
            queryClient.invalidateQueries({ queryKey: ["webhook-deliveries"] });
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to replay delivery");
        },
    });

    return { replayDeliveryMutate, isReplaying };
};
